const Validation = {
  required: 'This field is required',
  invalidEmail: 'Invalid email',
  invalidPhoneNumber: 'Invalid phone number',
};

export default Validation;
